import React, { Fragment, useContext, useState } from 'react';
import {Typography, Stack, Button} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CMSContext } from '../contexts/CMSContext';
import useLog from '../hooks/useLog';

const CMS_URL = process.env.REACT_APP_API_HOST; // Replace with actual CMS URL
const FUNCTION_KEY = process.env.REACT_APP_FUNCTION_KEY;

function DevicesView( {hideUI = false }) {

    const { t } = useTranslation();
    const {LogInfo, LogError} = useLog();
    const { devices, gateDevices } = useContext(CMSContext);
    const [buttonColors, setButtonColors] = useState({});
    const [loadingDevices, setLoadingDevices] = useState({}); // Track loading state per device
    const timer = 1000; // 1 second
    const openDoor = async (device) => {
        if (loadingDevices[device.deviceid]) return; // Prevent parallel requests
        try {
          setLoadingDevices(prev => ({ ...prev, [device.deviceid]: true }));
          setButtonColors(prev => ({ ...prev, [device.deviceid]: 'blue' }));
          const api = 'api/callpanel';
          const response = await fetch(`${CMS_URL}${api}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-functions-key': FUNCTION_KEY
            },
            body: JSON.stringify({ deviceId: device.deviceid,
                action: 'opendoor'
             })
          });
          
          if (response.status !== 200) {
            LogError('Failed to open door:', response.statusText);
            setButtonColors(prev => ({ ...prev, [device.deviceid]: 'red' }));
            setTimeout(() => {
              setButtonColors(prev => ({ ...prev, [device.deviceid]: 'transparent' }));
            }, timer);
          }
          else {
            LogInfo('door opened successfully:');
            setButtonColors(prev => ({ ...prev, [device.deviceid]: 'green' }));
          }
          setTimeout(() => {
            setButtonColors(prev => ({ ...prev, [device.deviceid]: 'transparent' }));
            setLoadingDevices(prev => ({ ...prev, [device.deviceid]: false })); // Reset loading state
          }, timer);
        } catch (error) {
          LogError('Failed to open door:', error);
          setButtonColors(prev => ({ ...prev, [device.deviceid]: 'red' }));
          setTimeout(() => {
            setButtonColors(prev => ({ ...prev, [device.deviceid]: 'transparent' }));
            setLoadingDevices(prev => ({ ...prev, [device.deviceid]: false })); // Reset loading state
          }, timer);
        }
      };
    
      if (hideUI) {
        return null; // Do not render UI
      }    
      return (
        <Fragment>
          {devices && 
          <Stack direction="column" sx={{m:2, alignItems: 'center'}}>
            <Typography variant="h4" color="white" align="center">{t('devices_open_door')}</Typography>
            <Stack direction="row">
              {devices.filter(device => device.devicetype === "base").map(device => (
                <Button key={device.deviceid}  onClick={() => openDoor(device)}  disabled={loadingDevices[device.deviceid]} sx={{
                  color: 'white', // White text
                  borderColor: 'white', // White border
                  borderRadius: '8px', // Rounded border
                  fontSize: '16px', // Larger font size
                  border: '1px solid', // Border style
                  width: '120px',
                  height: '120px', // Button width
                  margin: '8px',
                  backgroundColor: buttonColors[device.deviceid] || 'transparent',
                  '&:hover': {
                    backgroundColor: buttonColors[device.deviceid] && buttonColors[device.deviceid] !== 'transparent'
                      ? buttonColors[device.deviceid]
                      : 'rgba(255, 255, 255, 0.1)', // Background color on hover
                  },
                }}>
      {device.friendlyName}</Button>
              ))}
            </Stack>
          </Stack>
          }
          {gateDevices && 
          <Stack direction="column" sx={{m:2, alignItems: 'center'}}>
            <Typography variant="h4" color="white" align="center">{t('gate_devices')}</Typography>
            <Stack direction="row" >
              {gateDevices && gateDevices.map(device => (
                <Button key={device.deviceid} onClick={() => openDoor(device)} disabled={loadingDevices[device.deviceid]} sx={{
                  color: 'white', // White text
                  borderColor: 'white', // White border
                  borderRadius: '8px', // Rounded border
                  fontSize: '16px', // Larger font size
                  border: '1px solid', // Border style
                  padding: '8px 16px', // Padding for better appearance
                  width: '120px',
                  height: '120px', // Button width
                  margin: '8px',
                  backgroundColor: buttonColors[device.deviceid] || 'transparent',
                  '&:hover': {
                    backgroundColor: buttonColors[device.deviceid] && buttonColors[device.deviceid] !== 'transparent'
                      ? buttonColors[device.deviceid]
                      : 'rgba(255, 255, 255, 0.1)', // Background color on hover
                  },
                }}>{device.friendlyName}</Button>
              ))}
            </Stack>
          </Stack>
        } 
        </Fragment>
      );
    
}

export default DevicesView;